/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import React, { useEffect, useContext, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import Razorpay from '../Payment/RazorPay';
import Paypal from '../Payment/Paypal';
import Loading from '../../Loading';
import Stripe from '../Payment/Stripe';
import FlutterWave from '../Payment/FlutterWave';
import PayStack from '../Payment/PayStack';
import PayFast from '../Payment/PayFast';
import Midtrans from '../Payment/Midtrans';
import KhaltiPayment from '../Payment/KhaltiPayment';
import MercadoPago from '../Payment/MercadoPago';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const Wallet = () => {

    const { t } = useTranslation();
    const { BaseUrl, paymentRes, setPaymentRes, paymentLoad, setPaymentLod } = useContext(MyContext);

    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(true);
    const [myWallet, setMyWallet] = useState("");
    const [paymentList, setPaymentList] = useState([]);
    const [isPayment, setIsPayment] = useState(false);
    const [selectPayment, setSelectPayment] = useState("");
    const [attributes, setAttributes] = useState();
    const [transactionList, setTransactionList] = useState([]);

    const site_currency = sessionStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    useEffect(() => {
        window.scrollTo(0, 0);

        axios.post(`${BaseUrl}user_api/u_paymentgateway.php`)
            .then((res) => {
                // console.log("u_paymentgateway", res);
                setPaymentList(res.data.paymentdata);
                setLoading(false);
            })
            .catch((error) => {
                console.error("u_paymentgateway", error);
            });

        HandleGetList();


        const PaymentRes = sessionStorage.getItem("Paymentstatus");
        if (!PaymentRes) return;

        if (PaymentRes === "PaymentDone") {
            setPaymentRes("PaymentDone");
        } else {
            setPaymentRes("PaymentFaild");
        }

    }, []);

    const HandleGetList = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        axios.post(`${BaseUrl}user_api/u_wallet_report.php`, { uid: Userid })
            .then((res) => {
                // console.log("u_wallet_report", res);
                setTransactionList(res.data.Walletitem);
                setMyWallet(res.data.wallet);
            })
            .catch((error) => {
                console.error("u_wallet_report", error);
            });
    };

    const HnadleContinue = () => {

        if (paymentLoad) {
            showTost(t("Payment in Process !!"), "info");
            return;
        }

        if (!input) {
            showTost(t("Please Enter Amount !!"), "error");
            return;
        }

        if (!selectPayment) {
            showTost(t("Select Payment Method !!"), "error");
            return;
        }

        setIsPayment(true);
        setPaymentLod(true);
        sessionStorage.setItem("pages", "wallet");
    };

    useEffect(() => {
        if (!paymentRes) return;

        if (paymentRes === "PaymentDone") {
            HandleWalletAdd();
        } else {
            setInput("");
            setIsPayment(false);
            setSelectPayment("");
            setPaymentRes("");
            showTost("Payment Faild !!", "error");
            sessionStorage.setItem("Amount", "0");
            sessionStorage.setItem("Paymentstatus", "");
        }

    }, [paymentRes]);

    const HandleWalletAdd = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const Amount = sessionStorage.getItem("Amount");

        axios.post(`${BaseUrl}user_api/u_wallet_up.php`, { uid: Userid, wallet: input || Amount })
            .then((res) => {
                // console.log("u_wallet_up", res);
                setInput("");
                HandleGetList();
                showTost(res.data.ResponseMsg, "success");
                setIsPayment(false);
                setPaymentRes("");
                setSelectPayment("");
                sessionStorage.setItem("Amount", "0");
                sessionStorage.setItem("Paymentstatus", "");
            })
            .catch((error) => {
                console.error("u_wallet_up", error);
            });
    };

    return (
        <div className="width_container">
            <div className="wallet mt-[20px]">

                <div className="paylist_box scroll-container">
                    <h1 className="font-bold text-[18px]">{t("Add Wallet")}</h1>
                    <h1 className="font-bold text-[15px] text-gray-600">{t("Your Current Wallet Balance is")} <span className="text-[red]">{currency}{myWallet}</span> </h1>
                    <input type="number" onChange={(e) => setInput(e.target.value)} value={input} className="w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] mt-[10px] focus-within:outline-gray-400" placeholder={t("Amount")} />

                    <div className="mt-[20px]">
                        <h1 className="font-bold ">{t("Select Payment Method")}</h1>

                        <div className="flex flex-wrap items-center gap-[10px] mt-[10px] max-h-[480px] scroll-container">
                            {paymentList.map((item, index) => {
                                return <div onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} key={index} className={`payment_box border-[2px] border-solid ${selectPayment === item.id ? "border-gray-600" : "border-gray-300"} hover:border-gray-600r`}>
                                    <div className="flex items-center gap-[10px]">
                                        <img src={BaseUrl + item.img} className="w-[60px] h-[60px]" alt="" />
                                        <div className="">
                                            <h1 className="font-bold text-[16px] text-gray-700">{item.title}</h1>
                                            <p className="text-[14px] text-gray-500">{item.subtitle}</p>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <button onClick={HnadleContinue} className="payment_button">
                        {paymentLoad ? <span className="loader2 -mb-[5px]"></span> : t("Continue")}
                    </button>
                </div>

                <div className="transaction_box">
                    <h1 className="font-bold text-[16px]">{t("Your Recent Transaction")}</h1>
                    <div className="h-[665px] scroll-container">
                        {transactionList.map((item, index) => {
                            return <div key={index} className="p-[20px] flex items-center justify-between">
                                <div className="flex items-center gap-[20px]">
                                    <svg width="27" height="27" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V6H22V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M2 12L2 16L6 16C7.10457 16 8 15.1046 8 14V14C8 12.8954 7.10457 12 6 12L2 12Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>
                                    <div className="">
                                        <h1 className="font-bold text-[15px]">{item.tdate}</h1>
                                        <span className="text-[14px] text-gray-600">{item.status}</span>
                                    </div>
                                </div>
                                <p className="text-[15px]">{item.status === "Debit" ? "-" : "+"}{currency}{item.amt}</p>
                            </div>
                        })}
                    </div>
                </div>

            </div>

            {(isPayment && selectPayment === "4") && <Razorpay Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "1") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={input} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "2") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={input} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "7") && <FlutterWave Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "9") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <PayStack Amount={input} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "12") && <PayFast Amount={input} attributes={attributes} />}
            {(isPayment && selectPayment === "13") && <Midtrans Amount={input} />}
            {(isPayment && selectPayment === "15") && <KhaltiPayment Amount={input} />}
            {(isPayment && selectPayment === "16") && <MercadoPago Amount={input} />}

            {loading && <Loading />}

        </div>
    )
}

export default Wallet
/* jshint ignore:end */